import * as React from "react";
import type { SVGProps } from "react";
const SvgMap011 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="m3.6 4.2 16.306 16.27m-8.47-7.34-7.342 7.34m1.694 1.13h12.424a3.39 3.39 0 0 0 3.388-3.388V5.788A3.39 3.39 0 0 0 18.212 2.4H5.788A3.39 3.39 0 0 0 2.4 5.788v12.424A3.39 3.39 0 0 0 5.788 21.6Z"
    />
  </svg>
);
export default SvgMap011;
